<div class="flex bg-slate-100">
  <div class="flex flex-col flex-initial min-w-fit gap-1"><!-- categories -->
    <div *ngFor="let category of aggregateTypes">
      <div (click)="categoryFilter$.next(category.id)"
           class="flex gap-2 text-black hover:bg-slate-200 rounded p-2"
           [ngClass]="{'bg-slate-400': category.id === (categoryFilter$ | async) }"
      >
        <div class="flex flex-initial my-auto">
          <span class="my-auto" [icon]="category.icon"></span>
        </div>
        <div class="flex-1 text-left text-black my-auto">
          <div>{{ category.name | translate | ucfirst }}</div>
        </div>
      </div>
    </div>
  </div>
  <!-- resultats -->
  <div class="flex-1 bg-white border-l" style="min-width: 410px; max-height: 600px; overflow-y: auto">
    <div *ngFor="let item of filteredResults" class="max-h-96">
      <app-global-search-result-item [data]="item"></app-global-search-result-item>
    </div>
    <!-- <div class="w w-full">&nbsp;</div> -->
  </div>
</div>
